module.exports = __webpack_public_path__ + "static/media/class (10).4dab787b.webp";